module.exports = __webpack_public_path__ + "img/vacancias.7797d191.svg";